import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  Routes,
  Route,
  useParams,
  useNavigate,
  Navigate
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import SftGlobalData from './library/SftGlobalData';

import './App.css';
import './styles/christmas.scss';
// react-loader-spinner v6+ has built-in styles
import ErrorBoundary from './ErrorBoundary';
import DevScreen from './screens/DevScreen';
import LoginScreen from './screens/login/LoginScreen';
import EnvironmentScreen from './screens/environment/EnvironmentScreen';
import HomeScreen from './screens/HomeScreen';
import Header from './components/Header';
import Footer from './components/Footer';
import AuthScreen from './screens/AuthScreen';
import IntegrationScreen from './screens/IntegrationScreen';
import IntegrationDetailScreen from './screens/IntegrationDetailScreen';
import LeftSidebar from './components/sidebar/LeftSidebar';
import MailIntegrationsScreen from './screens/mailintegrations/MailIntegrationsScreen';
import MailIntegrationsSetup from './screens/mailintegrations/MailIntegrationsSetup';
import BirthdayScreen from './screens/BirthdayScreen';
import BirthdayDetailScreen from './screens/BirthdayDetailScreen';
import MobileModules from './screens/MobileModulesScreen';
import MobileModuleSettingsScreen from './screens/MobileModuleSettingsScreen';
import UploadsScreen from './screens/UploadsScreen';
import TimeClockScreen from './screens/timeclock/TimeClockScreen';
import TeamScreen from './screens/team/TeamScreen';
import LabelDesignerScreen from './screens/LabelDesignerScreen';
import UserScreen from './screens/UserScreen';
import ReportsScreen from './screens/ReportsScreen';
import RevenueMapScreen from './screens/RevenueMapScreen';
import DashboardScreen from './screens/DashboardScreen';
import UserDetailScreen from './screens/UserDetailScreen';
import UserDetailAppScreen from './screens/UserDetailAppScreen';
import LicenceScreen from './screens/licence/LicenceScreen';
import ShippingScreen from './screens/ShippingScreen';
import ShippingLogScreen from './screens/ShippingLogScreen';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ResetPasswordScreen from './screens/login/ResetPasswordScreen';
import crypto from 'crypto-js';
import CreateConnectionScreen from './screens/CreateConnectionScreen';
import AuthSftScreen from './screens/AuthSftScreen';
import AdminStatScreen from './screens/AdminStatScreen';
import ManualScreen from './screens/ManualScreen';
import ManualViewScreen from './screens/ManualViewScreen';
import ManualEditScreen from './screens/ManualEditScreen';
import Holiday from './components/Holiday';
import ChristmasLights from './components/ChristmasLights';
import LoggingScreen from './screens/logging/LoggingScreen';
import AuthLoginScreen from './screens/AuthLoginScreen';
import LoggingAddScreen from './screens/logging/LoggingAddScreen';
import LoggingAddScreenMobile from './screens/logging/LoggingAddScreenMobile';
import TemplateDetailScreen from './screens/template/TemplateDetailScreen';
import EticketScreen from './screens/eticket/EticketScreen';
import EticketDetailScreen from './screens/eticket/EticketDetailScreen';
import EticketWizardScreen from './screens/eticket/EticketWizardScreen';
import EinvoiceDetailScreen from './screens/eticket/EinvoiceDetailScreen';
import EcustomDetailScreen from './screens/eticket/EcustomDetailScreen';
import InformationScreen from './screens/InformationScreen';
import { Modal } from '@mui/material';
import { Box, Button, Fab, FormControl, InputLabel, ListItemText, MenuItem, Select, SpeedDial, SpeedDialAction, SpeedDialIcon, TextField, ThemeProvider, createTheme, styled } from '@mui/material';
import { CarRental, Checklist, Key, Layers, LayersClear } from '@mui/icons-material';
import Colors from './library/Colors';
import { PermissionsProvider } from './library/Permissions';
import ConnectionOverviewScreen from './screens/ConnectionOverviewScreen';
import QuizScreen from './screens/extras/QuizScreen';
import ExcelImportScreen from './screens/excel/ExcelImportScreen';
import ExcelScreen from './screens/excel/ExcelScreen';
import ExcelEditScreen from './screens/excel/ExcelEditScreen';
import ExactScreen from './screens/exact/ExactScreen';
import RMAScreen from './screens/rma/RmaScreen';
import RMADetailScreen from './screens/rma/RmaDetailScreen';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import HelpScreen from './screens/help/HelpScreen';
import TodoListScreen from './screens/extras/TodoListScreen';
import PeppolOverview from './screens/peppol/PeppolOverview';
import SchedulerScreen from './screens/scheduler/SchedulerScreen';
import CustomerDisplayScreen from './screens/customerDisplay/CustomerDisplayScreen';
import AiScreen from './screens/ai/AiScreen';
import WebshopConfigScreen from './screens/webshop/WebshopConfigScreen';
import WebshopActionsScreen from './screens/webshop/WebshopActionsScreen';
import { WebshopDesignProvider } from './screens/webshop/_designVariant';
import WebshopConnectionsScreen from './screens/webshop/WebshopConnectionsScreen';
import WebshopDataScreen from './screens/webshop/WebshopDataScreen';
import WebshopSetupScreen from './screens/webshop/WebshopSetupScreen';
import UnsavedChangesDialog from './components/UnsavedChangesDialog';
import { runUnsavedSaves, hasAnySaver, hasUnsavedChanges } from './library/UnsavedChangesGuard';
import { clearTeamToken, storeTeamToken } from './library/teamToken';


let lang = 'def';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  
function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );
  
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
  
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    return windowDimensions;
  }

const Backdrop = styled('div')`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const StyledModal = styled(Modal)`
  position: fixed;
  text-align: center;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;


const style = {
  bgcolor: 'background.paper',
  border: '0px solid #000',
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
  width: "100%",
  p: 2,
};


function App() {
    const [login, setLogin] = useState({sft_group: "", sft_status:"0", sft_user_id:""});
    const [dbs, setDbs] = useState([]);
    // Initialize selectedDb from sessionStorage if available
    const [selectedDb, setSelectedDbState] = useState(() => {
        try {
            const storedDb = sessionStorage.getItem('selectedDb');
            if (storedDb) {
                return JSON.parse(storedDb);
            }
        } catch (e) {
            console.error('Error loading selectedDb from sessionStorage:', e);
        }
        return {settings: {}};
    });

    // Wrapper function to set selectedDb and persist to sessionStorage
    const setSelectedDb = useCallback((db) => {
        setSelectedDbState(db);
        try {
            if (db && Object.keys(db).length > 0 && db.settings) {
                sessionStorage.setItem('selectedDb', JSON.stringify(db));
            }
        } catch (e) {
            console.error('Error saving selectedDb to sessionStorage:', e);
        }
    }, []);

    // ─── Webshop state ──────────────────────────────────────────────────────
    // Some clients have multiple webshops in lic_clients_webshop. We fetch the
    // list scoped to the current (client_id, db_id) once a db is selected, and
    // auto-select the first. The user can switch via an icon in the sidebar.
    const [availableWebshops, setAvailableWebshops] = useState([]);
    // Bumped to force a re-fetch of the webshop list (e.g. after a user
    // provisions their shop from the "no webshop" empty-state).
    const [webshopReloadTick, setWebshopReloadTick] = useState(0);
    const reloadWebshops = () => setWebshopReloadTick(v => v + 1);
    // Install state of the selected webshop (read-only probe). Drives the
    // sidebar: a not-yet-installed shop shows only the Setup wizard. Re-probed
    // on webshop change + after a provision/install/update (reloadWebshops).
    const [webshopStatus, setWebshopStatus] = useState(null);
    const [selectedWebshop, setSelectedWebshopState] = useState(() => {
        try {
            const stored = sessionStorage.getItem('selectedWebshop');
            return stored ? JSON.parse(stored) : null;
        } catch (e) {
            return null;
        }
    });

    const setSelectedWebshop = useCallback((webshop) => {
        setSelectedWebshopState(webshop);
        try {
            if (webshop) {
                sessionStorage.setItem('selectedWebshop', JSON.stringify(webshop));
            } else {
                sessionStorage.removeItem('selectedWebshop');
            }
        } catch (e) {
            console.error('Error saving selectedWebshop to sessionStorage:', e);
        }
    }, []);

    // Fetch webshops whenever the selected db changes.
    useEffect(() => {
        const dbKey = selectedDb?.encrypted_key;
        if (!dbKey || dbKey === SftGlobalData.defaultKey) {
            setAvailableWebshops([]);
            setSelectedWebshop(null);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const result = await SftGlobalData.post('webshop&action=list', { key: dbKey });
                if (cancelled) return;
                const list = (result && result.success) ? (result.data || []) : [];
                setAvailableWebshops(list);
                // Re-point the selection at the freshly fetched row: the id can
                // survive while url/display_name changed under it (a domain
                // change), and the stored copy is what every screen builds its
                // shop URLs from. Falls back to the first shop when the
                // selected one is gone.
                const fresh = selectedWebshop ? list.find(w => w.id === selectedWebshop.id) : null;
                if (fresh) {
                    if (JSON.stringify(fresh) !== JSON.stringify(selectedWebshop)) {
                        setSelectedWebshop(fresh);
                    }
                } else {
                    setSelectedWebshop(list[0] || null);
                }
            } catch (e) {
                if (!cancelled) {
                    console.error('Failed to fetch webshops list:', e);
                    setAvailableWebshops([]);
                    setSelectedWebshop(null);
                }
            }
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDb?.encrypted_key, webshopReloadTick]);

    const [theme, setTheme] = useState('');
    const [screen, setScreen] = useState('');
    const [key, setKey] = useState("");
    // Probe the selected webshop's install state (read-only). webshopReady =
    // mini-api reachable → the full admin tabs; otherwise only the Setup wizard.
    useEffect(() => {
        const id = selectedWebshop?.id;
        if (!id || !key) { setWebshopStatus(null); return; }
        let cancelled = false;
        SftGlobalData.post('webshop&action=status', { key, webshop_id: id, sftUserId: login?.sft_user_id, user: login?.login })
            .then(res => { if (!cancelled) setWebshopStatus(res?.success ? res.data : null); })
            .catch(() => { if (!cancelled) setWebshopStatus(null); });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedWebshop?.id, key, webshopReloadTick]);
    const webshopReady = !!webshopStatus?.miniApiOk;
    //const [menuExpanded, setMenuExpanded] = useState(true);
    const [mobileOpen, setMobileOpen] = useState(false);
    // Initialised from localStorage so the user's collapsed-sidebar choice
    // survives a reload. Auto-collapse below 800px still wins on resize, but
    // anywhere above that threshold the manual toggle is authoritative.
    const [hideSidebar, setHideSidebar] = useState(() => {
        try {
            const v = localStorage.getItem('hideSidebar');
            return v === 'true';
        } catch { return false; }
    });
    const [hideTopbar, setHideTopbar] = useState(false);
    const [holidays, setHolidays] = useState((typeof getCookie("holidays") !== "undefined") ? (getCookie("holidays") === "true") : true );
    const [modal, setModal] = useState(false);
    const [reason, setReason] = useState("");
    const [selectedConnUser, setSelectedConnUser] = useState("");
    //const [user, setUser] = useState();
    const drawerWidth = 250;
    // Compact-mode width — used when the user collapses the sidebar. Mirrors
    // the logging-screen sidebar size so the two visuals feel consistent.
    const compactDrawerWidth = 65;
    // The /kb (Help/manuals) screen relies on the full sidebar for topic
    // navigation, so we force it expanded there regardless of the user's
    // preference. State stays untouched — leaving /kb naturally restores
    // whatever they had before.
    const effectiveHideSidebar = (screen === 'help') ? false : hideSidebar;
    const effectiveDrawerWidth = effectiveHideSidebar ? compactDrawerWidth : drawerWidth;
    const params = useParams();
    const { height, width } = useWindowDimensions();
    const navigate = useNavigate();

    // "Switch database" (the header icon) wipes selectedDb BEFORE navigating
    // to the picker, but the previous db-scoped screen stays in the browser
    // history — so Back landed you on e.g. webshop-config without a database
    // (stale context from the previous customer). Bounce those straight back
    // to the picker. selectedDb restores synchronously from sessionStorage in
    // its useState initializer, so a hard refresh on a webshop URL with a
    // selected db never triggers this.
    useEffect(() => {
        const dbSelected = typeof selectedDb?.encrypted_key !== 'undefined';
        const sub = String(params['*'] || '');
        if (!dbSelected && /^webshop(-|$)/.test(sub) && login?.sft_user_id) {
            navigate('/' + (params.lang || 'nl') + (login?.sft_status != '0' ? '/env' : '/environment'), { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params, selectedDb, login]);

    let today = new Date();
    // Once the user makes an explicit choice (via the Header toggle) we
    // record that here. As long as it's set, the auto-resize rule below
    // is skipped and the manual choice wins. Without the ref, an auto-fire
    // on the next resize would silently overwrite the user's intent.
    const userToggledSidebarRef = useRef(
        (() => { try { return localStorage.getItem('hideSidebar') !== null; } catch { return false; } })()
    );

    useEffect(()=>{
        if (userToggledSidebarRef.current) return; // manual choice wins
        if(width <= 800 && !hideSidebar){
            setHideSidebar(true);
        } else if (width > 800 && hideSidebar){
            setHideSidebar(false);
        }
    }, [width]);

    // Reflect collapse state on <body> so any screen using the global
    // `.expanded` CSS class snaps to full width without per-screen edits.
    useEffect(() => {
        document.body.classList.toggle('sidebar-hidden', !!effectiveHideSidebar);
    }, [effectiveHideSidebar]);

    const toggleSidebar = useCallback(() => {
        userToggledSidebarRef.current = true;
        // Also reset mobileOpen — the LeftSidebar render condition is
        // `(hideSidebar === false || mobileOpen === true)`, so a stray
        // `mobileOpen=true` left over from an earlier interaction would
        // keep the sidebar mounted even after we collapse it. Resetting
        // here keeps both flags in sync.
        setMobileOpen(false);
        setHideSidebar(prev => {
            const next = !prev;
            try { localStorage.setItem('hideSidebar', String(next)); } catch { /* quota */ }
            return next;
        });
    }, []);

    const textFieldRef = useRef(null);
    useEffect(() => {
        if (modal) {
            textFieldRef.current?.focus();
        }
    }, [modal]);

    const setInputRef = useCallback((element) => {
            textFieldRef.current = element;
            if (element) {
              element.focus();
              element.select();
            }
          }, []);

    useEffect(() => {
        // Default theme fetcher
        let cachedTheme = '';
        try{
            cachedTheme = localStorage.getItem('theme');
            if(cachedTheme === null){
                cachedTheme = '';
            }
        }catch(e){
            if(SftGlobalData.debug){
                console.error("error", e);
            }
            cachedTheme = '';
        }
        
        if(cachedTheme === ''){
            const isDarkTheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
            if(isDarkTheme){
                setTheme('dark');
                document.body.style.backgroundColor = '#232B38';
            } else{
                setTheme('light');
                document.body.style.backgroundColor = '#f2f3f5';
            }
        } else {
            setTheme(cachedTheme);
            if(cachedTheme === 'dark'){
                document.body.style.backgroundColor = '#232B38';
            } else {
                document.body.style.backgroundColor = '#f2f3f5';
            }
        }
        

        // session key flow
        try{
            if(key===""){
                try{
                    if(typeof getCookie("cred") !== "undefined"){
                        setLogin(JSON.parse(crypto.AES.decrypt(getCookie("cred"), 'Soft295Touch!').toString(crypto.enc.Utf8)));
                    }
                }catch(e){
                    
                }
                const sidebarCollapsed = localStorage.getItem("left_sidebar-collapsed");
                let sessionKey = sessionStorage.getItem('key');
                let sessionLogin = null;
                try{
                    var data = crypto.AES.decrypt(sessionStorage.getItem('login'), 'Soft295Touch!');
                    data = data.toString(crypto.enc.Utf8);
                    if(SftGlobalData.debug){
                        console.log("logged in", data);
                    }
                    sessionLogin = JSON.parse(data);

                }catch(e){
                    /*if(SftGlobalData.debug){
                        console.error('error', e);
                    }*/
                    sessionLogin = null;
                }
                if(SftGlobalData.debug){
                    console.log("Session key", sessionKey);
                    console.log("Session login", sessionLogin);
                }
                if(sessionLogin !== null){
                    try{setCookie("cred", crypto.AES.encrypt(JSON.stringify({sft_group: sessionLogin.sft_group, sft_status:sessionLogin.sft_status, sft_user_id:sessionLogin.sft_user_id}), 'Soft295Touch!').toString(), 0.5);}catch(ex){console.error(ex);}
                    setLogin(sessionLogin);
                    SftGlobalData.isSuperUser = sessionLogin?.sft_group === "SUPER";
                    setDbs(sessionLogin.dbs);
                }

                if(sessionKey !== "" && sessionKey !== "undefined" && sessionKey !== null){
                    setKey(sessionKey);
                    if(sessionKey === SftGlobalData.defaultKey){
                        setHideSidebar(true);
                    }
                    let APIurl = SftGlobalData.baseURL_API + 'auth';
                    axios.post(APIurl, {key: sessionKey}, {
                        headers : {
                            'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                        }})
                        .then(response => {
                            if(SftGlobalData.debug){
                                console.log('response err', typeof response.error);
                            }
                            if(typeof response.error === 'undefined'){
                                if(SftGlobalData.debug){
                                    console.log('response', response);
                                }
                                //setDbs(response.data.dbs);
                                if(response.data?.dbs?.length > 0) {
                                    // Check if we already have a selectedDb stored
                                    const storedDb = sessionStorage.getItem('selectedDb');
                                    if (!storedDb || storedDb === '{}' || JSON.parse(storedDb)?.settings && Object.keys(JSON.parse(storedDb).settings).length === 0) {
                                        // Only set the first db if we don't have a valid one stored
                                        setSelectedDb(response.data.dbs[0]);
                                    }
                                }                                    
                            } else { 
                                notify(t('errorOccured'), 7500, "top-center", theme, 1);                       
                            }
                        });
                } else {
                    if(!window.location.href.includes("/user/password-reset") ){
                        //navigate("/"+params.lang+"/login");
                    }
                }
                if(SftGlobalData.debug){
                    console.log('sideBarCollapsed', sidebarCollapsed);
                }
                // setMenuExpanded(sidebarCollapsed === 'true' ? false : true);
            }else {
                if(key === SftGlobalData.defaultKey){
                    setHideSidebar(true);
                }
            }
        }catch(e){
            if(SftGlobalData.debug){
                console.log(e);
            }
        }
    }, [key]);

    // Check every minute if the session cookie has expired (12h TTL)
    useEffect(() => {
        const interval = setInterval(() => {
            if(key !== "" && key !== SftGlobalData.defaultKey && getCookie("cred") === ""){
                sessionStorage.removeItem('login');
                sessionStorage.removeItem('key');
                clearTeamToken();
                setKey("");
                setLogin({});
                setDbs([]);
                window.location.href = "/" + lang + "/login";
            }
        }, 60000);
        return () => clearInterval(interval);
    }, [key, lang]);

    // Ctrl/Cmd+S → save the current screen. Reuses the UnsavedChangesGuard
    // savers (the same fns the unsaved-changes modal's "Save & continue" runs),
    // so it works on any screen that registers one (webshop config, data, …).
    // We only hijack the shortcut when a saveable screen is mounted (hasAnySaver)
    // so on other screens the browser's default Ctrl+S is left untouched; the
    // actual save only fires when there are unsaved changes (no "nothing to
    // save" toast on every press).
    useEffect(() => {
        const onKeyDown = (e) => {
            const isSaveCombo = (e.ctrlKey || e.metaKey) && !e.altKey && (e.key === 's' || e.key === 'S');
            if (!isSaveCombo || !hasAnySaver()) return;
            e.preventDefault();
            if (hasUnsavedChanges()) runUnsavedSaves();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    function getEasterDate(jump) {
        const year = today.getFullYear();
        // Computus algorithm to calculate the date of Easter
        // This algorithm is based on the Gregorian calendar
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
    
        // Months are 0-indexed in JavaScript Date object, so we subtract 1 from the month
        let easterDate = new Date(year, month - 1, day);

        if(jump) {
            easterDate.setDate(easterDate.getDate() + 7);
        } else {
            easterDate.setDate(easterDate.getDate() - 7);
        }
    
        return (new Date(easterDate));
    }

    var christmasDateFrom = new Date("12/07/"+today.getFullYear());
    var christmasDateTo = new Date("12/31/"+(today.getFullYear()));
    var christmasDateEnd = new Date("01/15/"+(today.getFullYear()));
    var halloweenDateFrom = new Date("10/25/"+today.getFullYear());
    var halloweenDateTo = new Date("11/01/"+(today.getFullYear()));
    var valentinesDateFrom = new Date("02/14/"+today.getFullYear());
    var valentinesDateTo = new Date("02/15/"+(today.getFullYear()));
    var easterDateFrom = getEasterDate(false);
    var easterDateTo = getEasterDate(true);

    const holidayCheck = () => {
        if(!holidays) return "";
        else {
            if((today <= christmasDateTo && today >= christmasDateFrom) || today <= christmasDateEnd) return "christmas";
            else if(today >= easterDateFrom && today <= easterDateTo) return "easter";
            else if(today >= halloweenDateFrom && today <= halloweenDateTo) return "halloween";
            else if(today >= valentinesDateFrom && today <= valentinesDateTo) return "valentines";
            else return "";
        }
    }


    if(SftGlobalData.debug){
        console.log("height", height);
        console.log("width", width);
        console.log("params", params);
        console.log("screen", screen);
    }

    const { t, i18n } = useTranslation();

    if((params.lang === 'nl' || params.lang === 'en' || params.lang === 'fr') && lang !== params.lang){
        i18n.changeLanguage(params.lang);
        lang = params.lang;
    }

    const toggleTheme = () => {
        localStorage.removeItem('theme');
        if(theme === 'dark'){
            setTheme('light');
            document.body.style.backgroundColor = '#f2f3f5';
            localStorage.setItem('theme', 'light');
        } else {
            setTheme('dark');
            document.body.style.backgroundColor = '#232B38';
            localStorage.setItem('theme', 'dark');
        }
    }

    const cacheLogin = (loginData) => {
        setLogin(loginData);
        // The leave planner's token is shared with the other tabs (links from planner mails open a new tab).
        if (loginData?.team_token) storeTeamToken(loginData.team_token); else clearTeamToken();
        SftGlobalData.isSuperUser = loginData?.sft_group === "SUPER";
        sessionStorage.removeItem('login');
        var data = crypto.AES.encrypt(JSON.stringify(loginData), 'Soft295Touch!');
        data = data.toString();
        sessionStorage.setItem('login', data);
        try{setCookie("cred", crypto.AES.encrypt(JSON.stringify({sft_group: loginData.sft_group, sft_status:loginData.sft_status, sft_user_id:loginData.sft_user_id}), 'Soft295Touch!').toString(), 0.5);}catch(ex){console.error(ex);}

    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        
    }

    const refreshWithGoogle = () => {
        if (typeof window.google === 'undefined') {
            notify(t('errorOccured') + ': Google service not available', 7500, "top-center", theme, 1);
            return;
        }

        // Initialize Google Identity Services
        window.google.accounts.id.initialize({
            client_id: SftGlobalData.google_client_id,
            callback: (response) => {
                const googleToken = response.credential;

                if (!googleToken) {
                    notify(t('errorOccured'), 7500, "top-center", theme, 1);
                    return;
                }

                // Send to existing OAuth endpoint
                let APIurl = SftGlobalData.baseURL_API + 'oauth&action=google';
                let postData = {
                    google_token: googleToken,
                    app_id: 1
                };

                axios.post(APIurl, postData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                .then(response => {
                    if (SftGlobalData.debug) {
                        console.log('Google refresh url', APIurl);
                        console.log('Google refresh response', response);
                    }

                    if (typeof response.error === 'undefined' && response.data && response.data.is_valid) {
                        setDbs(response.data.dbs);
                        notify(t('succes'), 2000, "top-center", theme, 2);
                    } else {
                        notify(t('errorOccured'), 7500, "top-center", theme, 1);
                    }
                })
                .catch(error => {
                    console.error('Google refresh error:', error);
                    notify(t('errorOccured'), 7500, "top-center", theme, 1);
                });
            },
            auto_select: false
        });

        // Trigger Google One Tap
        window.google.accounts.id.prompt();
    }

    const refreshWithApple = () => {
        if (typeof window.AppleID === 'undefined') {
            notify(t('errorOccured') + ': Apple service not available', 7500, "top-center", theme, 1);
            return;
        }

        // Initialize Apple Sign-In
        window.AppleID.auth.init({
            clientId: SftGlobalData.apple_client_id,
            scope: 'name email',
            redirectURI: window.location.origin + '/auth/apple/callback',
            state: 'mysofttouch-refresh',
            usePopup: true
        });

        // Start Apple Sign-In
        window.AppleID.auth.signIn()
            .then(response => {
                const appleToken = response.authorization.id_token;

                if (!appleToken) {
                    notify(t('errorOccured'), 7500, "top-center", theme, 1);
                    return;
                }

                // Send to existing OAuth endpoint
                let APIurl = SftGlobalData.baseURL_API + 'oauth&action=apple';
                let postData = {
                    apple_token: appleToken,
                    app_id: 1
                };

                axios.post(APIurl, postData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                .then(response => {
                    if (SftGlobalData.debug) {
                        console.log('Apple refresh url', APIurl);
                        console.log('Apple refresh response', response);
                    }

                    if (typeof response.error === 'undefined' && response.data && response.data.is_valid) {
                        setDbs(response.data.dbs);
                        notify(t('succes'), 2000, "top-center", theme, 2);
                    } else {
                        notify(t('errorOccured'), 7500, "top-center", theme, 1);
                    }
                })
                .catch(error => {
                    console.error('Apple refresh error:', error);
                    notify(t('errorOccured'), 7500, "top-center", theme, 1);
                });
            })
            .catch(error => {
                console.error('Apple Sign-In error:', error);
                notify(t('errorOccured'), 7500, "top-center", theme, 1);
            });
    }

    const onRefresh = () => {
        try{
            // Check if this is an OAuth login
            if (login?.oauth_provider === 'google') {
                refreshWithGoogle();
                return;
            } else if (login?.oauth_provider === 'apple') {
                refreshWithApple();
                return;
            }

            // Regular login flow
            let APIurl = SftGlobalData.baseURL_API + 'login';
            let postData = {
                login: login?.login,
                password: login?.password
            };
            axios.post(APIurl, postData, {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                }})
                .then(response => {
                    if(SftGlobalData.debug){
                        console.log('url', APIurl);
                        console.log('data', postData);
                        console.log('response', response);
                        console.log('response error', typeof response.error);
                    }
                    if(typeof response.error === 'undefined'){
                        if(!response.data.is_valid){
                            notify(t('invalid_credentials'), 7500, "top-center", theme, 1);
                        } else {
                            //props.cacheLogin(response.data);
                            setDbs(response.data.dbs);
                        }
                    } else {
                        notify(t('errorOccured'), 7500, "top-center", theme, 1);
                    }
                })
        }catch(e){
            console.error(e);
        }
    }


    const notify = (text, time, position, theme, id) => {
        toast(text, {autoClose: time, position:position, theme:theme, toastId: id});
    }

    const requestDbAccess = (reqLogin, db, reqReason) => {
        let isAdmin = reqLogin?.sft_group == "SUPER" ? true : false;
        if(reqReason !== "" || isAdmin){
            setReason("");
            if(typeof db !== "undefined" && typeof reqLogin !== "undefined"){
                try{
                    let postData = { key: db.encrypted_key, sft_status: reqLogin.sft_status, sft_user_id: reqLogin.sft_user_id, reason: reqReason };
                    SftGlobalData.post('permission&action=request', postData).then(response => {
                         notify(response.status == 200 ? response.data.message : response.message, 2000, "bottom-center", theme, 87879); 
                    });
                } catch(e){
                    console.error(e);
                    notify("DENIED: Something went wrong, check the connection to softtouch.eu...", 2000, "bottom-center", theme, 87879); 
                }
            } else {
                notify("DENIED: Not logged in correctly or invalid DB selected.", 2000, "bottom-center", theme, 87879); 
            }
        } else {
            notify("DENIED: Reason is required.", 2000, "bottom-center", theme, 87879); 
        }
    }

    const authorizeDbAccess = (user, db, reqReason) => {
        setReason("");
        if(typeof db !== "undefined" && user !== ""){
            try{
                let postData = { key: db.encrypted_key, sft_status: "2", sft_user_id: user, reason: reqReason };
                SftGlobalData.post('permission&action=request', postData).then(response => {
                    notify(response.status == 200 ? response.data.message : response.message, 2000, "bottom-center", theme, 87879); 
                });
            } catch(e){
                console.error(e);
                notify("DENIED: Something went wrong, check the connection to softtouch.eu...", 2000, "bottom-center", theme, 87879); 
            }
        } else {
            notify("DENIED: Not logged in correctly or invalid DB selected.", 2000, "bottom-center", theme, 87879); 
        }
    }

    const darkTheme = createTheme({
        palette: {
          mode: 'dark',
          secondary: {
            main: Colors.sft_blue_text,
            light: Colors.sft_blue_text,
            dark: Colors.sft_blue_darker
          },
        },
        mixins: {
            MuiDataGrid: {
              containerBackground: Colors.dark_basic,
            },
        },
        typography: {
            fontFamily: [
              'Nunito',
              'Ubuntu',
              'sans-serif'
            ].join(','),
          },
      });

    const lightTheme = createTheme({
        palette: {
            mode: 'light',
            primary: {
                main: Colors.sft_blue,
                light: Colors.sft_blue_text,
                dark: Colors.sft_blue_darker
              },
            secondary: {
              main: Colors.sft_blue_text,
              light: Colors.sft_blue_text,
              dark: Colors.sft_blue_darker
            },
        },
        mixins: {
            MuiDataGrid: {
              containerBackground: Colors.light_basic,
            },
        },
        typography: {
            fontFamily: [
              'Nunito',
              'Ubuntu', 
              'sans-serif'
            ].join(','),
          },
    });

    const [todoOpen, setTodoOpen] = useState(false);
    
    const [speedActions, setSpeedActions] = useState(
        login?.sft_group === "SUPER" ? [
        { 
            icon: <Key />, 
            name: 'Authorize self', 
            onClick: () => { requestDbAccess(login, selectedDb, reason); }
        },
        { 
            icon: <CarRental />, 
            name: 'Authorize another', 
            onClick: () => { setModal(true); }
        },
        { 
            icon: <Checklist />, 
            name: 'To-do list', 
            onClick: () => { toggleTodoOpen(); }
        },
      ] :
      [
        { 
            icon: <Key />, 
            name: 'Authorize self', 
            onClick: () => { setModal(true); }
        },
        { 
            icon: <Checklist />, 
            name: 'To-do list', 
            onClick: () => { toggleTodoOpen(); }
        },
      ]);

      useEffect(()=>{
        if(typeof selectedDb?.encrypted_key === "undefined"){
            setSpeedActions([
                { 
                    icon: <Checklist />, 
                    name: 'To-do list', 
                    onClick: () => { toggleTodoOpen(); }
                }
              ]);
        } else{
            setSpeedActions(login?.sft_group === "SUPER" ? [
                { 
                    icon: <Key />, 
                    name: 'Authorize self', 
                    onClick: () => { requestDbAccess(login, selectedDb, reason); }
                },
                { 
                    icon: <CarRental />, 
                    name: 'Authorize another', 
                    onClick: () => { setModal(true); }
                },
                { 
                    icon: <Checklist />, 
                    name: 'To-do list', 
                    onClick: () => { toggleTodoOpen(); }
                },
              ] :
              [
                { 
                    icon: <Key />, 
                    name: 'Authorize self', 
                    onClick: () => { setModal(true); }
                },
                { 
                    icon: <Checklist />, 
                    name: 'To-do list', 
                    onClick: () => { toggleTodoOpen(); }
                },
              ]);
        }
            
    }, [selectedDb]);

    const toggleTodoOpen = () => {
        setTodoOpen(true);
    }

    // Quick actions (authorise self / authorise another / to-do list), shown in the left sidebar just above
    // the language switch. Same rights as the former floating SpeedDial and the status-3 key button:
    // - support staff with status 1/2 (not on the webshop editors): to-do list always; with a selected database
    //   also "authorise self" (SUPER: request access directly, others: via the dialog) and, for SUPER, "authorise another";
    // - status 3 (not SUPER) with a selected database: "authorise self" via the dialog.
    const quickActions = (() => {
        const isSft = typeof login?.sft_user_id !== "undefined";
        const hasDb = typeof selectedDb?.encrypted_key !== "undefined";
        const isSuper = login?.sft_group === "SUPER";
        const actions = [];
        if (isSft && login?.sft_status != "3" && login?.sft_status != "0" && screen !== 'webshop' && screen !== 'webshop-config') {
            if (hasDb) {
                actions.push({ key: 'self', label: 'Authorize self', icon: <Key fontSize="small" />,
                    onClick: () => { if (isSuper) { requestDbAccess(login, selectedDb, reason); } else { setModal(true); } } });
                if (isSuper) actions.push({ key: 'another', label: 'Authorize another', icon: <CarRental fontSize="small" />, onClick: () => { setModal(true); } });
            }
            actions.push({ key: 'todo', label: 'To-do list', icon: <Checklist fontSize="small" />, onClick: () => { toggleTodoOpen(); } });
        } else if (isSft && hasDb && login?.sft_status == "3" && !isSuper) {
            actions.push({ key: 'self', label: 'Request access', icon: <Key fontSize="small" />, disabled: modal, onClick: () => { setModal(true); } });
        }
        return actions;
    })();
    // Where a left sidebar is rendered the actions live there; elsewhere (environment selection) they stay floating.
    const sidebarShown = screen === 'logging' || (screen !== 'login' && screen !== 'environment' && screen !== 'quiz' && hideTopbar === false);

    // Role-simulator temporarily restricted to one dev account (user 1031)
    // while the permissions framework awaits its backend; widen back to
    // SUPER (or per-user assignment) once that lands.
    return (
        <PermissionsProvider t={t} muiTheme={theme === "dark" ? darkTheme : lightTheme} showSimulator={String(login?.sft_user_id) === "1031" && (screen || '').startsWith('webshop')}>
        <WebshopDesignProvider>
        <div className="main-app-container">
            <div className={`main-content ${todoOpen ? "content-shift" : ""}`}>
                <div className={"App "}>
                    {login?.sft_status != "0" && holidayCheck() === "christmas" && <Holiday occasion={"snow"} />}
                    {login?.sft_status != "0" && holidayCheck() === "halloween" && <Holiday occasion={"bat"} />}
                    {login?.sft_status != "0" && holidayCheck() === "valentines" && <Holiday occasion={"heart"} />}
                    {login?.sft_status != "0" && holidayCheck() === "easter" && <Holiday occasion={"egg"} />}
                    {holidays && login?.sft_status != "0" && (screen !== 'login' && screen !== 'environment' && effectiveHideSidebar === false) && (today <= christmasDateTo && today >= christmasDateFrom) && <ChristmasLights />}
                    {(screen !== 'login' && screen !== 'quiz' && hideTopbar === false) && <Header login={login} hideSidebar={effectiveHideSidebar} api={key} sftUserId={login?.sft_user_id} dbName={login?.sft_status != "0" ? selectedDb.description : ""} selectedWebshop={selectedWebshop} group={login?.sft_group} t={t} lang={params.lang} emptyDbs={()=>{setDbs([])}} toggleMobileOpen={()=>{setMobileOpen(!mobileOpen);}} toggleSidebar={toggleSidebar} toggleDatabase={() => {setSelectedDb({settings: {}}); sessionStorage.removeItem('selectedDb');}} screenWidth={width} mobileOpen={mobileOpen} drawerWidth={effectiveDrawerWidth} theme={theme} screen={screen} dbs={dbs} toggleTheme={()=>{toggleTheme();}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}} />}
                    {(screen !== 'login' && screen !== 'environment' && screen !== 'logging' && hideTopbar === false) && <LeftSidebar quickActions={quickActions} api={key} screen={screen} changeScreen={(screenName)=>{setScreen(screenName);}} group={login?.sft_group} holiday={holidayCheck()} is_sft={login?.sft_status != "0"} toggleMobileOpen={()=>{setMobileOpen(!mobileOpen);}} mobileOpen={mobileOpen} compact={effectiveHideSidebar} lang={params.lang} drawerWidth={effectiveDrawerWidth} modules={selectedDb.settings} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}  db={selectedDb} login={login} availableWebshops={availableWebshops} selectedWebshop={selectedWebshop} setSelectedWebshop={setSelectedWebshop} webshopReady={webshopReady}  t={t} />}
                    {screen === 'logging' && <LeftSidebar quickActions={quickActions} api={key} selectDb={(db, key)=>{setSelectedDb(db); setKey(key);}} holiday={holidayCheck()} pathname={params["*"]} screen={screen} modules={{}} sft_stat={login?.sft_status} group={login?.sft_group} is_sft={login?.sft_status != "0"} toggleMobileOpen={()=>{setMobileOpen(!mobileOpen);}} mobileOpen={mobileOpen} lang={params.lang} drawerWidth={65} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}} login={login} screenWidth={width} db={selectedDb} availableWebshops={availableWebshops} selectedWebshop={selectedWebshop} setSelectedWebshop={setSelectedWebshop}  t={t} />}
                    <ErrorBoundary theme={theme} screenWidth={width} >
                        <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
                            {/* Global unsaved-changes confirmation — screens
                                register their dirty state in the guard; this
                                dialog shows WHAT would be lost before leaving. */}
                            <UnsavedChangesDialog t={t} theme={theme} />
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className={((hideTopbar === false) ? "app-content" :  "app-content margin_top_none ") + (width<810 ? " height_100perc " : "") + (screen === "quiz" ? " margin_top_none " : "") }>
                                    <Routes>
                                        <Route path='*' element={<LoginScreen screenWidth={width} t={t} lang={params.lang} cacheLogin={(data)=>{cacheLogin(data);}} useDbs={(dbs)=>{setDbs(dbs)}} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='dev' element={<DevScreen screenWidth={width} lang={params.lang} api={key} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='login' element={<LoginScreen screenWidth={width} t={t} lang={params.lang} holiday={holidayCheck()} cacheLogin={(data)=>{cacheLogin(data);}} useDbs={(dbs)=>{setDbs(dbs)}} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='login/:error' element={<LoginScreen screenWidth={width} t={t} lang={params.lang} holiday={holidayCheck()} cacheLogin={(data)=>{cacheLogin(data);}} useDbs={(dbs)=>{setDbs(dbs)}} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='user/password-reset/:token' element={<ResetPasswordScreen screenWidth={width} t={t} lang={params.lang} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='environment' element={<EnvironmentScreen todo={todoOpen} onRefresh={()=>{onRefresh();}} maxHeight={height} sftUserId={login?.sft_user_id} group={login?.sft_group} sftStatus={login?.sft_status} screenWidth={width} t={t} lang={params.lang} dbs={dbs} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} selectDb={(db, key)=>{setSelectedDb(db); setKey(key);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='env' element={<EnvironmentScreen todo={todoOpen} onRefresh={()=>{onRefresh();}} maxHeight={height} sftUserId={login?.sft_user_id} noAutoRedirect={true} group={login?.sft_group} sftStatus={login?.sft_status} screenWidth={width} t={t} lang={params.lang} dbs={dbs} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} selectDb={(db, key)=>{setSelectedDb(db); setKey(key);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='home' element={<HomeScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='peppol' element={<PeppolOverview screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} loginObj={login} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='auth/:key' element={<AuthScreen lang={params.lang} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='auth/:key/:redirect' element={<AuthScreen lang={params.lang} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='authentication/:key' element={<AuthScreen lang={params.lang} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='authentication/:key/:redirect' element={<AuthScreen lang={params.lang} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='authentication/:key/:redirect/:val' element={<AuthScreen lang={params.lang} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='authentication/:key/:redirect/:val/:val2' element={<AuthScreen lang={params.lang} theme={theme} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />

                                        <Route path='mobile' element={<MobileModules screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} groupId={'0000'} isSft={login?.sft_status != "0"} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='mobile/uploads' element={<UploadsScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} isSft={login?.sft_status != "0"} sftUserId={login?.sft_user_id} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='mobile/designer' element={<LabelDesignerScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} isSft={login?.sft_status != "0"} sftUserId={login?.sft_user_id} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='mobile/designer/:src/:name' element={<LabelDesignerScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} isSft={login?.sft_status != "0"} sftUserId={login?.sft_user_id} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='mobile/label-designer' element={<LabelDesignerScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} isSft={login?.sft_status != "0"} sftUserId={login?.sft_user_id} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='mobile/label-designer/:src/:name' element={<LabelDesignerScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} isSft={login?.sft_status != "0"} sftUserId={login?.sft_user_id} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='module/:module' element={<MobileModuleSettingsScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} groupId={'0000'} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='module/:module/:groupId' element={<MobileModuleSettingsScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} groupId={'0000'} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />

                                        <Route path='timeclock' element={<TimeClockScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='users' element={<UserScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        {(login?.sft_group === "SUPER" || Number(selectedDb?.settings?.modReports) === 1) && <Route path='reports' element={<ReportsScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} sftUserId={login?.sft_user_id} userLogin={login?.login} isSft={login?.sft_status != "0"} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(login?.sft_group === "SUPER" || key !== "") && <Route path='reports/map' element={<RevenueMapScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} sftUserId={login?.sft_user_id} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(login?.sft_group === "SUPER" || key !== "") && <Route path='reports/dashboard' element={<DashboardScreen t={t} lang={params.lang} api={key} changeScreen={(screenName)=>{setScreen(screenName);}}/>} />}
                                        <Route path='user-detail/:userId' element={<UserDetailScreen group={login?.sft_group} isSft={login?.sft_status != "0"} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='user-detail/:userId/:appId' element={<UserDetailAppScreen defaults={false} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='app-defaults' element={<UserDetailAppScreen defaults={true} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />

                                        <Route path='shipping-log' element={<ShippingLogScreen screenWidth={width} t={t} lang={params.lang} login={login} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} hideSidebar={hideSidebar} setHideSidebar={(hideSidebar)=>{setHideSidebar(hideSidebar);}} hideTopbar={hideTopbar} setHideTopbar={(hideTopbar)=>{setHideTopbar(hideTopbar);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='shipping' element={<ShippingLogScreen screenWidth={width} t={t} lang={params.lang} login={login} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} hideSidebar={hideSidebar} setHideSidebar={(hideSidebar)=>{setHideSidebar(hideSidebar);}} hideTopbar={hideTopbar} setHideTopbar={(hideTopbar)=>{setHideTopbar(hideTopbar);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='shipping/new' element={<ShippingScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} hideSidebar={hideSidebar} setHideSidebar={(hideSidebar)=>{setHideSidebar(hideSidebar);}} hideTopbar={hideTopbar} setHideTopbar={(hideTopbar)=>{setHideTopbar(hideTopbar);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='shipping/:receiptNr' element={<ShippingScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} hideSidebar={hideSidebar} setHideSidebar={(hideSidebar)=>{setHideSidebar(hideSidebar);}} hideTopbar={hideTopbar} setHideTopbar={(hideTopbar)=>{setHideTopbar(hideTopbar);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='shipping/:receiptNr/:storeId' element={<ShippingScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} hideSidebar={hideSidebar} setHideSidebar={(hideSidebar)=>{setHideSidebar(hideSidebar);}} hideTopbar={hideTopbar} setHideTopbar={(hideTopbar)=>{setHideTopbar(hideTopbar);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />

                                        <Route path='excel' element={<ExcelScreen login={login} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='excel/:mod' element={<ExcelImportScreen login={login} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='rma' element={<RMAScreen login={login} screenWidth={width} hideSidebar={hideSidebar} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='rma/:search' element={<RMAScreen login={login} screenWidth={width} hideSidebar={hideSidebar} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='rma/detail/:rmaId' element={<RMADetailScreen login={login} hideSidebar={hideSidebar} maxHeight={height} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='rma/detail/:rmaId/:storeId' element={<RMADetailScreen login={login} hideSidebar={hideSidebar} maxHeight={height} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        
                                        <Route path='scheduler' element={<SchedulerScreen setSelectedDb={(db)=>{setSelectedDb(db);}} screenWidth={width} login={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='customer-display' element={<CustomerDisplayScreen setSelectedDb={(db)=>{setSelectedDb(db);}} screenWidth={width} login={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='ai' element={<AiScreen login={login} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />

                                        {/* POC: Webshop admin — forced routes, backend wiring still pending */}
                                        <Route path='webshop-config' element={<WebshopConfigScreen login={login} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} selectedWebshop={selectedWebshop} onProvisioned={reloadWebshops} hideSidebar={effectiveHideSidebar} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='webshop-actions' element={<WebshopActionsScreen availableWebshops={availableWebshops} screenWidth={width} lang={params.lang} t={t} api={key} theme={theme} selectedWebshop={selectedWebshop} login={login} onProvisioned={reloadWebshops} onSelectWebshop={setSelectedWebshop} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='webshop-connections' element={<WebshopConnectionsScreen screenWidth={width} lang={params.lang} t={t} theme={theme} api={key} login={login} selectedWebshop={selectedWebshop} onProvisioned={reloadWebshops} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='webshop-data' element={<WebshopDataScreen screenWidth={width} lang={params.lang} t={t} theme={theme} api={key} login={login} selectedWebshop={selectedWebshop} onProvisioned={reloadWebshops} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='webshop-setup' element={<WebshopSetupScreen screenWidth={width} lang={params.lang} t={t} theme={theme} api={key} login={login} selectedWebshop={selectedWebshop} setSelectedWebshop={setSelectedWebshop} availableWebshops={availableWebshops} onProvisioned={reloadWebshops} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />

                                        {(login.sft_user_id !== "" || key !== "") && <Route path='kb' element={<HelpScreen screen={screen} hideSidebar={hideSidebar} screenWidth={width} t={t} lang={params.lang} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}} login={login}/>} />}
                                        {(login.sft_user_id !== "" || key !== "") && <Route path='kb/:id' element={<HelpScreen screen={screen} hideSidebar={hideSidebar} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(login.sft_user_id !== "" || key !== "") && <Route path='kb/:id/:value' element={<HelpScreen screen={screen} login={login} hideSidebar={hideSidebar} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}

                                        {(typeof login.sft_user_id !== "undefined") && <Route path='eticket' element={<EticketScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined") && <Route path='eticket-wizard' element={<EticketWizardScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined") && <Route path='eticket/:listId/:elementId' element={<EticketDetailScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined") && <Route path='einvoice/:listId/:elementId' element={<EinvoiceDetailScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined") && <Route path='ecustom/:listId/:elementId' element={<EcustomDetailScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {
                                            //---------------------------
                                            // SOFTTOUCH ONLY ROUTES    |
                                            //---------------------------
                                        }
                                        <Route path='lic-auth/:key' element={<AuthSftScreen lang={params.lang} t={t} theme={theme} cacheLogin={(data)=>{cacheLogin(data);}} useDbs={(dbs)=>{setDbs(dbs)}}  changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        <Route path='override_core_protection/:redirect/:key' element={<AuthLoginScreen lang={params.lang} t={t} theme={theme} cacheLogin={(data)=>{cacheLogin(data);}} useDbs={(dbs)=>{setDbs(dbs)}}  changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='environment/:id' element={<CreateConnectionScreen screenWidth={width} t={t} lang={params.lang} dbs={dbs} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} sftStatus={login?.sft_status} setDbs={(databases)=>{setDbs(databases);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='logging' element={<LoggingScreen login={login?.login} loginObj={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && width > 900 && <Route path='logging/add' element={<LoggingAddScreen setSelectedDb={(db)=>{setSelectedDb(db);}} screenWidth={width} login={login?.login} loginObj={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && width <= 900 && <Route path='logging/add' element={<LoggingAddScreenMobile screenWidth={width} login={login?.login} loginObj={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='logging/logs' element={<LoggingScreen login={login?.login} loginObj={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='logging/customers' element={<Navigate replace to={'/' + params.lang + '/logging/logs?tab=customers'} />} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='licence' element={<LicenceScreen onRefresh={()=>{onRefresh();}} login={login?.login} loginObj={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='admin-stats' element={<AdminStatScreen userId={login?.sft_user_id} loginObj={login} username={login?.first_name} group={login?.sft_group} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='adminstats' element={<AdminStatScreen userId={login?.sft_user_id} loginObj={login} username={login?.first_name} group={login?.sft_group} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='connections' element={<ConnectionOverviewScreen login={login?.login} loginObj={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}

                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='integrations' element={<IntegrationScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='channable-detail/:listId' element={<IntegrationDetailScreen integration="channable" screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='google-detail/:listId' element={<IntegrationDetailScreen integration="google" screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='facebook-detail/:listId' element={<IntegrationDetailScreen integration="facebook" screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='mail-integrations' element={<MailIntegrationsScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} sftUserId={login?.sft_user_id} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='mail-integrations/:id' element={<MailIntegrationsSetup screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} sftUserId={login?.sft_user_id} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}

                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='birthday' element={<BirthdayScreen screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='birthday-detail/:listId' element={<BirthdayDetailScreen screenWidth={width} t={t} lang={params.lang} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='manuals' element={<ManualScreen screen={screen} screenWidth={width} t={t} lang={params.lang} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}} login={login}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='manuals/view/:id' element={<ManualViewScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='manuals/edit/:id' element={<ManualEditScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                    
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='templates' element={<Navigate replace to={'/' + params.lang + '/manuals?tab=templates'} />} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='templates/edit/:id' element={<TemplateDetailScreen screen={screen} login={login} screenWidth={width} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='team' element={<TeamScreen screenWidth={width} t={t} lang={params.lang} theme={theme} login={login} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='user-info' element={<InformationScreen screen={screen} screenWidth={width} t={t} lang={params.lang} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}} login={login} holidays={holidays} toggleHolidays={()=>{setHolidays(!holidays); setCookie("holidays", !holidays);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='quiz' element={<QuizScreen login={login} screenWidth={width} t={t} lang={params.lang} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}} setHideSidebar={(hideSidebar)=>{setHideSidebar(hideSidebar);}}/>} />}
                                    
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0") && <Route path='excel/edit/:mod' element={<ExcelEditScreen login={login} screenWidth={width} t={t} lang={params.lang} db={selectedDb} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                        {(typeof login.sft_user_id !== "undefined" && login?.sft_status != "0" && login?.sft_group === "SUPER") && <Route path='exact' element={<ExactScreen setSelectedDb={(db)=>{setSelectedDb(db);}} screenWidth={width} login={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} t={t} lang={params.lang} selectedDb={selectedDb} api={key} theme={theme} dbs={dbs} setDbs={(databases)=>{setDbs(databases);}} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}}/>} />}
                                    </Routes> 
                                </div>
                            </LocalizationProvider>
                        </ThemeProvider>
                    </ErrorBoundary>
                    {(screen !== 'login' && screen !== 'quiz') && <Footer lang={lang} theme={theme} screen={screen} db={selectedDb}/>}
                    {/* Floating dev/admin Fab + SpeedDial. Push them right of
                        the sidebar (full or compact) so they don't sit on top
                        of the icon rail and the language footer. Screens that
                        don't render a sidebar (login, environment, logging)
                        keep the original left:14 placement. */}
                    {(() => {
                        const sidebarRendered = screen !== 'login' && screen !== 'environment' && screen !== 'logging' && screen !== 'quiz';
                        // /logging renders its own compact 65px icon-rail sidebar
                        // (the dedicated <LeftSidebar drawerWidth={65}> above) with
                        // the language switchers at the bottom — clear that rail too.
                        // The Fab carries an extra 8px inner margin (m:1), so +4 here
                        // already reads as ~12px clearance from the rail edge.
                        const speedLeft = screen === 'logging' ? 65 + 4
                            : sidebarRendered ? effectiveDrawerWidth + 14 : 14;
                        return (
                            <>
                                {!sidebarShown && (typeof selectedDb?.encrypted_key !== "undefined" && login?.sft_status == "3" && typeof login?.sft_user_id !== "undefined" && login?.sft_group !== "SUPER") && <Box disabled={modal} onClick={()=>{if(login?.sft_group === "SUPER" ) {requestDbAccess(login, selectedDb, reason)}else{setModal(true)}}} style={{position: 'fixed', left: speedLeft, bottom: 24, zIndex: 1250}} sx={{ '& > :not(style)': { m: 1 } }}>
                                    {(screen !== 'login' && screen !== 'environment' && screen !== 'quiz') && <Fab disabled={modal} size="medium" sx={{ backgroundColor: Colors.sft_blue, color: Colors.sft_blue_text }} aria-label="Request access">
                                        <Key />
                                    </Fab>}
                                </Box>}
                                {!sidebarShown && (typeof login?.sft_user_id !== "undefined" && login?.sft_status != "3" && login?.sft_status != "0" && screen !== 'login' && screen !== 'quiz' && screen !== 'webshop' && screen !== 'webshop-config') && (
                                    <SpeedDial
                                        ariaLabel="SpeedDial basic example"
                                        sx={{ '& > :not(style)': { m: 1 }  }}
                                        icon={<SpeedDialIcon icon={<Layers />} openIcon={<LayersClear />}/>}
                                        size="medium"
                                        style={{position: 'fixed', left: speedLeft, bottom: 24, zIndex: 1250}}>
                                        {speedActions.map((action) => (
                                          <SpeedDialAction
                                            key={action.name}
                                            icon={action.icon}
                                            tooltipTitle={action.name}
                                            onClick={()=>{action.onClick();}}
                                          />
                                        ))}
                                    </SpeedDial>)}
                            </>
                        );
                    })()}
                    
                    <StyledModal
                        aria-labelledby="unstyled-modal-title"
                        aria-describedby="unstyled-modal-description"
                        open={modal}
                        onClose={()=>{setModal(false)}}
                        BackdropComponent={Backdrop}
                        >
                        <Box sx={style} style={{minHeight: 300, backgroundColor: (theme === 'dark' ? Colors.dark_basic : Colors.light_basic)}} className={theme + " slide-in-bottom"}>
                            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                {login?.sft_group !== "SUPER" && <h2>Request access</h2>}
                                <p style={{margin: 5}}>You are requesting access to: <b>{selectedDb.description}</b></p>
                                <div style={{maxWidth: 350, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', width: '100%', textAlign: 'left'}}>
                                    {login?.sft_group === "SUPER" && <FormControl style={{ width: '100%', marginTop: 10}}>
                                        <InputLabel id="demo-simple-select-label-art">{t('user')}:</InputLabel>
                                        <Select id="User"
                                        className={theme+"_accent "+theme+"_text _100perc"}
                                        labelId="demo-simple-select-label-art" 
                                        label={t('user')} 
                                        value={selectedConnUser} 
                                        onChange={(e) => {setSelectedConnUser(e.target.value)}} 
                                        style={{ maxHeight: 43 }}
                                        >
                                            <MenuItem value={""} name={"-"}><ListItemText primary={"-"} /></MenuItem>
                                            {/*<MenuItem value={"1018"} name={"sft_bert_vdv"}><ListItemText primary={"Bert (sft_bert_vdv)"} /></MenuItem>*/}
                                            <MenuItem value={"1033"} name={"Demo (sft_demo)"}><ListItemText primary={"Demo (sft_demo)"} /></MenuItem>
                                            <MenuItem value={"1030"} name={"sft_gianni_r"}><ListItemText primary={"Gianni (sft_gianni_r)"} /></MenuItem>
                                            <MenuItem value={"1017"} name={"sft_louis_w"}><ListItemText primary={"Louis (sft_louis_w)"} /></MenuItem>
                                            <MenuItem value={"1027"} name={"sft_ruben_dr"}><ListItemText primary={"Ruben (sft_ruben_dr)"} /></MenuItem>
                                            <MenuItem value={"1036"} name={"sft_siemen_r"}><ListItemText primary={"Siemen (sft_siemen_r)"} /></MenuItem>
                                            <MenuItem value={"1034"} name={"sft_vincent_vdh"}><ListItemText primary={"Vincent (sft_vincent_vdh)"} /></MenuItem>
                                            {/*<MenuItem value={""} name={""}><ListItemText primary={""} /></MenuItem>*/}
                                        </Select>
                                    </FormControl>}
                                    <TextField
                                        required
                                        multiline
                                        minRows={2}
                                        maxRows={2}
                                        inputProps={{ maxLength: 255 }}
                                        autoComplete="off" 
                                        style={{width: '100%', marginTop: 5, marginBottom: 5}}
                                        className={theme+ '_accent '}
                                        id="reason"
                                        label={t('reason')}
                                        size={'small'}
                                        sx={(theme==='light') ? {
                                            '& .MuiOutlinedInput-input': {
                                                color: Colors.light_text
                                              },
                                            '& .MuiInputLabel-root': {
                                                color: Colors.light_text
                                             }, borderRadius: 3, marginTop: 0} 
                                            :
                                            {
                                            '& .MuiOutlinedInput-input': {
                                                color: Colors.dark_text
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: Colors.dark_text_accent
                                                }, borderRadius: 3, marginTop: 0}}
                                        value={reason}
                                        onChange={(event)=>{setReason(event.target.value)}}
                                        inputRef={setInputRef} 
                                        />
                                    <Button 
                                        variant="outlined" 
                                        sx={{ borderRadius: 3, border: '2px solid '+Colors.sft_blue, color: Colors.sft_blue}}
                                        style={{width: '100%', marginTop: 5}} 
                                        onClick={()=>{
                                            setModal(false); 
                                            if(login?.sft_group !== "SUPER") requestDbAccess(login, selectedDb, reason);
                                            else authorizeDbAccess(selectedConnUser,selectedDb, reason);
                                        }}>Request DB access</Button>
                                </div>
                            </div>
                            {screen !== 'login' && <Footer lang={lang} theme={theme} screen={screen} db={selectedDb}/>}
                        </Box>
                    </StyledModal>
                    <ToastContainer style={{marginTop: ((screen !== 'login' && hideTopbar === false) ? 50 : 0)}} />
                </div>
                {screen !== 'login' && <div className={`todo-sidebar ${todoOpen ? "open" : "hidden"}`} style={{ zIndex: 998, overflowY: 'auto', padding: 10, backgroundColor: theme === "dark" ? Colors.dark_basic : Colors.light_basic }}>
                    <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
                        <TodoListScreen login={login?.login} loginObj={login} userId={login?.sft_user_id} username={login?.first_name} group={login?.sft_group} screenWidth={width} t={t} lang={params.lang} api={key} theme={theme} changeScreen={(screenName)=>{setScreen(screenName);}} notify={(text, time, position, theme, id) => {notify(text, time, position, theme, id);}} close={()=>{setTodoOpen(false);}}/>
                    </ThemeProvider>
                </div>}
            </div>
        </div>
        </WebshopDesignProvider>
        </PermissionsProvider>
    );
}

export default App;
